import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from '@/plugins/i18n-instance'
import './plugins'
import { axiosRequest } from '@/utils/request.js'
import VueTypedJs from 'vue-typed-js'
import AOS from 'aos'
import '../node_modules/aos/dist/aos.css'
import '@/styles/swipe-tabs.scss'
import canonicalMixin from '@/mixins/canonical'
import { schedulePrerenderReady } from '@/utils/prerender'

Vue.prototype.$axios = axiosRequest
Vue.mixin(canonicalMixin)
Vue.use(AOS)
AOS.init()
Vue.use(VueTypedJs)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  i18n,
  mounted () {
    // Initial fallback for routes without async API calls.
    schedulePrerenderReady(1500)
  },
  render: h => h(App),
}).$mount('#app')
